// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__00G8o","logo__icon":"Logo_logo__icon__SwrYC","logo__text":"Logo_logo__text__UC8CI"};